export const SocialData = [
  {
    platform: "Github",
    icon: require("../../assets/icons/github.png"),
    link: "https://github.com/krishal2003",
  },

  {
    platform: "instagram",
    icon: require("../../assets/icons/twitter.png"),
    link: "https://instagram.com/krisalbasnet",
  },
  {
    platform: "Facebook",
    icon: require("../../assets/icons/facebook.png"),
    link: "https://www.facebook.com/people/Krisal-Basnet/pfbid0X9etT3uJV4DBHv8a9g6yLfhaJA1k9LJzozq9YhsvUFmqyT42RhWvzLYxMNuba5Qxl/?mibextid=b06tZ0",
  },
];